import type { Nullable } from "../types";
import { guardNumber } from "./guard-number";

/**
 * This function is used to calculate the progress of two values.
 */
export function getProgress(_goal: Nullable<number>, _current: Nullable<number>) {
	if (!_goal && !_current) return 100;
	const goal = guardNumber(_goal);
	const current = guardNumber(_current);
	return Math.max(Math.min((current / goal) * 100, 100), 0);
}
